/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsClockRotateRight: {
  name: 'clock-rotate-right';
  data: string;
} = {
  name: 'clock-rotate-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.985.879a.5.5 0 0 0-.97.242l.156.623a8.753 8.753 0 0 0-.298-.178C10.948 1.037 9.612.5 8 .5A7.5 7.5 0 1 0 15.5 8a.5.5 0 0 0-1 0A6.5 6.5 0 1 1 8 1.5c1.388 0 2.553.463 3.377.934l.113.066H11a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .485-.621l-.5-2ZM8.5 5a.5.5 0 1 0-1 0v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1H8.5V5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
